<div class="tringle-area">
  <div class="tringle"></div>
</div>
<div class="container-fluid">
  <nav class="px-0 navbar navbar-expand-lg navbar-light">
    <a class="navbar-brand" href="/op48?onpassive={{ userId }}">
      <img
        src="{{ onPassiveBaseUrl }}onpassive-landing2/images/logo.png"
        alt="logo"
        class="img-fluid"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" id="home-nav">
          <a class="nav-link" href="/op48?onpassive={{ userId }}"
            >Home <span class="sr-only">(current)</span></a
          >
        </li>
        <li class="nav-item" id="about-nav">
          <a class="nav-link" href="/op48-aboutUs?onpassive={{ userId }}"
            >About Us</a
          >
        </li>
        <li class="nav-item" id="our_leaders">
          <a class="nav-link" href="/op48-ourLeaders?onpassive={{ userId }}"
            >Our Leaders</a
          >
        </li>
        <li class="nav-item dropdown" id="product-nav">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Products
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <div class="caret-icon">
              <i class="fa fa-caret-up" aria-hidden="true"></i>
            </div>
            <a class="dropdown-item" href="/registration/user?reg={{ userId }}"
              >O-Founders
              <span class="d-icon">
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation22/images/logo.png"
                  alt="icon-1" /></span
            ></a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="https://trimurl.co/"
              >Trim URL
              <span class="d-icon">
                <img
                  src="https://trimurl.co/images/trim_favicon.png"
                  alt="img-fluid" /></span
            ></a>
          </div>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            target="_blank"
            rel="noopener"
            href="https://careers.onpassive.com"
            >Careers</a
          >
        </li>

        <li class="nav-item" id="contact-nav">
          <a class="nav-link" href="/op48-contact-us?onpassive={{ userId }}"
            >Contact Us</a
          >
        </li>
        <li class="nav-item" id="blog-nav">
          <a
            class="nav-link"
            target="_blank"
            rel="noopener"
            href="https://onpassive.com/blog"
            >Blog</a
          >
        </li>
      </ul>
    </div>
  </nav>
</div>
<section class="slide-banner">
  <owl-carousel
    [options]="SlideOptions"
    [carouselClasses]="['owl-theme', 'sliding']"
  >
    <div class="slider-item" id="one">
      <div class="item item-one">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-landing2/images/banner/1.png"
          alt="images not found"
        />
        <div class="cover cover-one">
          <div class="container">
            <div class="header-content header-content-one">
              <div class="line animated bounceInLeft"></div>
              <span class="h1">100% Hands Free</span>
              <h2>Completely Done-For-You</h2>
              <span class="h1">Automated Online Success </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-item" id="two">
      <div class="item item-two">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-landing2/images/banner/2.png"
          alt="images not found"
        />
        <div class="cover">
          <div class="container">
            <div class="header-content">
              <div class="line animated bounceInLeft"></div>
              <span class="h1"> Our Business is </span>
              <h2>Your Success</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-item" id="three">
      <div class="item item-three">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-landing2/images/banner/3.png"
          alt="images not found"
        />
        <div class="cover">
          <div class="container">
            <div class="header-content">
              <div class="line animated bounceInLeft"></div>
              <h2 class="text-uppercase">First time</h2>
              <span class="h1 text-uppercase"
                >never-seen-before <br />
                technology
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-item" id="four">
      <div class="item item-four item-four-current">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-landing2/images/banner/4.png"
          alt="images not found"
        />
        <div class="cover">
          <div class="container">
            <div class="header-content">
              <div class="line animated bounceInLeft"></div>
              <h3>
                A legacy that will take care <br />
                of the next-gen business magnates
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-item" id="five">
      <div class="item item-five item-four">
        <img
          src="{{ onPassiveBaseUrl }}onpassive-landing2/images/banner/5.png"
          alt="images not found"
        />
        <div class="cover">
          <div class="container">
            <div class="header-content">
              <div class="line animated bounceInLeft"></div>
              <span class="h1">A profound</span>
              <h2>heart-deep commitment</h2>
              <span class="h1">to supersize your business</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </owl-carousel>
</section>
<section class="about position-relative about-p">
  <div class="container">
    <div class="row align-items-center justify-content-between">
      <div class="col-lg-6">
        <h1>ONPASSIVE</h1>
        <h5 class="robo">BRIDGING AI AND BUSINESSES GLOBALLY</h5>
        <p>
          The world today is running fast. And this rat-race is so competitive
          that we all want to be ahead of everyone. What if you had 'something'
          that would boost your growth towards success and give you an upper
          hand in life without having to do anything?
        </p>
        <p>
          Always wondered about ways to simplify life and work? How about some
          tools that could do this for your business? Amplify your business
          gigantically with ONPASSIVE's predictive, intelligent business
          automation platform.
        </p>
        <div class="slide-toggle">
          <p>
            It is said that thoughts become a reality. And that 'something' is a
            reality today. ONPASSIVE AI is that opportunity.. that wizard's key
            which is designed to change your destiny. Why wait for more when you
            have it in your hands!
          </p>
          <p>
            Designed by the brilliant master-mind Mr Ash Mufareh, ONPASSIVE is
            genuinely a magnificent outcome of his far-sightedness towards
            implementing Artificial Intelligence in business development. Mr
            Mufareh thought ahead of time before the future could knock on your
            door.
          </p>
          <p>
            ONPASSIVE is the only business of its kind that has all the required
            products helping you with a full transformation of your business. A
            unique digital platform that has everything done for you. If
            ONPASSIVE does not have it, then you do not need it.
          </p>
          <p>
            ONPASSIVE guarantees success to you as it empowers you, giving
            motion to your dreams. Let your business gain momentum with
            ONPASSIVE with the tools that are exclusively designed to give you
            results in real-time.
          </p>
          <p>
            Time to leave your old lifestyle back as ONPASSIVE promises to
            improve your lifestyle. Taste freedom in a completely new and
            different flavour as ONPASSIVE provides you with healthier methods
            to cope with your daily life routine.
          </p>
          <p>
            Take the decision to move ahead and embrace this sole vision of
            ONPASSIVE to bring happiness to everyone in a world which is full of
            chaos, crisis and most importantly, failure. Let the transformation
            begin with ONPASSIVE at the helm.
          </p>
          <p>
            Stay productive with ONPASSIVE even while enjoying a vacation at any
            of your favorite destinations as ONPASSIVE provides ground-breaking
            tools enabled by up-to-the-minute AI technology letting your
            business momentum in this fast-paced world smoothly.
          </p>
          <p>
            With business automation, you can operate your establishment without
            the hassle and create steady yet exponentially growing profits.
          </p>
          <p>
            Join ONPASSIVE and get a turnkey business delivered. Sit back and
            witness your wealth grow exponentially. Leap for a change, and you
            will find what you are looking for.
          </p>
        </div>
        <a
          href="javascript:void(0)"
          class="btn btn-outline-primary mt-3 btn-primary toggle text-white"
        >
          Read More
        </a>
      </div>
      <div class="col-lg-5">
        <div class="about-area">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="about-inner">
                <h4>Security</h4>
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/hello1.png"
                  alt="hello1"
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="about-inner">
                <h4>Automation</h4>
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/hello2.png"
                  alt="hello2"
                  class="img-fluid"
                />
              </div>
              <div class="about-inner">
                <h4>Reliability</h4>
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/hello3.png"
                  alt="hello3"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="product-categories products">
  <div class="container">
    <div class="cate-title">
      <h2 class="text-uppercase">ONPASSIVE</h2>
      <h5 class="robo">OUR PROPRIETARY PRODUCTS</h5>
    </div>
    <div class="row">
      <div class="col">
        <div class="categories-inner bg-1 button" id="bg-1">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/1.png"
            alt="1"
            class="img-fluid"
          />
          <h4>
            Digital<br />
            Marketing
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container1" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Digital Marketing</h2>
            <p>
              Beat the marketing blues with digital advertisements to targeted
              audience and outsourcing of marketing tasks along with customized
              crowd-funding, unlimited rotators and funnels, bringing in traffic
              round the clock, etc
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-2 button" id="bg-2">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/2.png"
            alt="2"
            class="img-fluid"
          />
          <h4>
            Video<br />
            Conference
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container2" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Video Conferencing</h2>
            <p>
              Communicate in sound & vision with the team with automated
              identification of best meeting timings and meeting location based
              on previous data on attendees, creating rooms and inviting people
              with a single mouse click
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-3 button" id="bg-3">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/3.png"
            alt="3"
            class="img-fluid"
          />
          <h4 style="height: 34px">VPN</h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container3" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>VPN</h2>
            <p>
              The most advanced and the world’s most exceptional VPN tool that
              encrypts your online data to stay entirely secure and unknown on
              the Internet enable your business to be safe and easy to access
              from anywhere for the mobility of work with security.
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-4 button" id="bg-4">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/4.png"
            alt="4"
            class="img-fluid"
          />
          <h4>
            Website<br />
            Builder
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container4" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Website Builder</h2>
            <p>
              Build your website without manual code editing using AI-powered
              website builder that offers enhanced user satisfaction including
              voice search and other necessary features simply by choosing the
              options that you want
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-5 button" id="bg-5">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/5.png"
            alt="5"
            class="img-fluid"
          />
          <h4>
            Video<br />
            Marketing
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container5" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Video Marketing</h2>
            <p>
              Helps to integrate intriguing videos into the marketing campaigns
              that helps to grow much faster as this is the best way to boost
              the overall marketing conversions. Improve overall marketing
              metrics through increased click-through rates
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
    </div>
    <div class="row">
      <div class="col">
        <div class="categories-inner bg-6 button" id="bg-6">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/6.png"
            alt="6"
            class="img-fluid"
          />
          <h4>
            ONPASSIVE<br />
            ConnectMe
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container6" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>ONPASSIVE ConnectMe</h2>
            <p>
              A platform that helps to be in touch with team or communicate with
              the target audience without any external disturbance. Remote
              working made easy with efficient working of meeting all customers’
              demands over conferences.
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-7 button" id="bg-7">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/7.png"
            alt="7"
            class="img-fluid"
          />
          <h4>
            Email<br />
            Marketing
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container7" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Email Marketing</h2>
            <p>
              Automated process to nurture target leads through emails and
              convert them into customers. Access to the best communication
              channel that helps with customization of the any emailing list
              with a guaranteed higher conversion rates
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-8 button" id="bg-8">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/8.png"
            alt="8"
            class="img-fluid"
          />
          <h4>
            Video<br />
            Chat
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container8" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Video Chat</h2>
            <p>
              Communication made easy with the team over an online face-to-face
              conversation through webcams. A dedicated software for seamless
              interaction for expansion of business ideas on a one-to-one chat
              or a one-to-many chat at a single point of time
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-9 button" id="bg-9">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/9.png"
            alt="9"
            class="img-fluid"
          />
          <h4>
            IP<br />
            Tracker
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container9" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>IP Tracker</h2>
            <p>
              Gives information on a host name, location, and other info about
              an IP address, who visited your website, their queries, etc. as
              you get rendered and recorded data for any IP address for a
              specific time through designed IPv6 subnets
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-10 button" id="bg-10">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/10.png"
            alt="10"
            class="img-fluid"
          />
          <h4>
            Calendar <br />
            Scheduler
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container10" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Calendar Scheduler</h2>
            <p>
              An automated solution that lets a virtual assistant to schedule
              multiple and recursive meetings or any important event. It is
              automated to invite the required people to the meeting and send
              out action items and daily itineraries
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
    </div>
    <div class="row">
      <div class="col">
        <div class="categories-inner bg-11 button" id="bg-11">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/11new.png"
            alt="11new"
            class="img-fluid"
          />
          <h4>
            Domain <br />
            Registration
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container11" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Domain Registration</h2>
            <p>
              Get a Fully Qualified Domain Name, or simply FQDN, with the one
              having complete URL structure, consisting of Zero-Level,
              Top-Level, Second-Level and Third-Level Domain as per your
              requirements and name preference
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-12 button" id="bg-12">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/12.png"
            alt="12"
            class="img-fluid"
          />
          <h4>
            Staff <br />
            Manager
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container12" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Staff Manager</h2>
            <p>
              A holistic solution to effortlessly enhance team collaboration
              through scheduling, assigning and prioritizing tasks to enhance
              communication & hence, teamwork with the access to obtain
              intuitive reports & analytics dashboards
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-13 button" id="bg-13">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/13.png"
            alt="13"
            class="img-fluid"
          />
          <h4>
            Mass Bulk <br />
            Mailing
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container13" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Mass Bulk Mailing</h2>
            <p>
              Access to email a large group of people through a single mailing
              system in one go as the system records all the email ids and that
              be edited to any point of time. Emailing to the team is now much
              easier with this tool
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-14 button" id="bg-14">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/14.png"
            alt="14"
            class="img-fluid"
          />
          <h4>
            Flexible <br />
            Wallet
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container14" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Flexible Wallet</h2>
            <p>
              A digital wallet to easily manage all financial transactions that
              accommodates all types of payment modes including crypto, fiat,
              bank cards, etc. The most secured way for all transactions
              including tracking and a record of all transactions
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
      <div class="col">
        <div class="categories-inner bg-15 button" id="bg-15">
          <img
            src="{{
              onPassiveBaseUrl
            }}onpassive-landing2/images/categories2/15.png"
            alt="15"
            class="img-fluid"
          />
          <h4>
            Live <br />
            Events
          </h4>
        </div>
      </div>
      <!-- Modal Open-->
      <div id="modal-container15" class="modal-container">
        <div class="modal-background">
          <div class="modal">
            <h2>Live Events</h2>
            <p>
              Experience a smooth communication of all events in real time like
              video hosting, webinars, audio conferences, etc. that helps to
              provide a better communication with the target audience thus,
              fulfilling an important marketing strategy
            </p>
            <svg
              class="modal-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
            >
              <rect
                x="0"
                y="0"
                fill="none"
                width="226"
                height="162"
                rx="3"
                ry="3"
              ></rect>
            </svg>
          </div>
        </div>
      </div>
      <!-- Modal end-->
    </div>
  </div>
</section>
<section class="video-area text-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12 text-center">
        <h4 class="robo text-capitalize">
          Learn about our exclusive ONPASSIVE culture
        </h4>
        <h2 class="robo mb-3">
          ACCENTUATED LEARNING ABOUT OUR BUSINESS <br />
          SOLUTIONS THROUGH ONPASSIVE CULTURE VIDEOS
        </h2>
        <p>
          The internet has taken the world by a storm in a positively
          unimaginable way. The business world is completely toppled by having
          all the resources it requires for the successful initiation of an
          enterprise.
        </p>
        <p>
          Access our ONPASSIVE video learning process, which is a
          super-effective way to know and understand us. Learn through
          custom-made videos by the top business leaders and entrepreneurs who
          are a part of this wonderful.. of this outstanding AI-driven business
          platform.
        </p>
        <p>
          Get to know how ONPASSIVE developed and evolved from a Product Suite
          to a Smart Business Solution (SBS) with AI at the helm, providing a
          completely automated business platform for everyone from start-ups to
          industry conglomerates.
        </p>
        <p>
          Have an in-depth understanding of how each proprietary product is
          coded and infused with AI to streamline productivity efficiently.
          Enhance your business performance with ONPASSIVE's breakthrough
          technology that is shifting paradigms
        </p>
        <!--  <a  class="btn btn-outline-primary mt-3 btn-primary toggle text-white" href="javascript:void(0)">
                       Read More
                    </a> -->
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="video_box acc_panel mb-4">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{
                  onPassiveBaseUrl
                }}onpassive-landing2/images/video-poster2.png"
                data-setup="{}"
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="products">
  <div class="container">
    <h2 class="mb-4 text-center text-uppercase">Products</h2>
    <div id="product_slider" class="carousel slide" data-ride="carousel">
      <!-- The slideshow -->
      <owl-carousel-o [options]="SlideOptions">
        <ng-template carouselSlide class="carousel-item active">
          <div class="product-bg">
            <div class="products-logo">
              <img
                src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
                class="img-fluid"
                alt="Become a Founder | O-Founders Sign UP"
              />
            </div>
            <div class="row align-items-center justify-content-between">
              <div class="col-lg-4">
                <div class="products-view">
                  <h4 class="robo mb-4">"You are in it to win it"</h4>
                  <img
                    src="{{ myLinksS3URL }}meterial/assets/images/graphic4.svg"
                    alt="graphic4"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="col-lg-8">
                <div class="products-view">
                  <div class="video_box acc_panel mb-4 mr-auto">
                    <video
                      id="my-video"
                      class="video-js video-size w-100 h-auto"
                      controls
                      preload="auto"
                      poster="{{
                        onPassiveBaseUrl
                      }}onpassive-landing2/images/video-poster.png"
                      data-setup="{}"
                    >
                      <source
                        src="{{
                          onPassiveBaseUrl
                        }}onpassive-landing2/images/Big-Mission.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                  <!--<h4 class="robo">"You are in it to win it"</h4>-->
                </div>
              </div>
              <div class="col-lg-12">
                <p class="text-justify">
                  Get guided and motivated by the top leaders from the
                  prestigious FOUNDERS community to help thousands of
                  individuals to start their dream business & make it a
                  successful one. Build your team and be a part of our esteemed
                  community.
                </p>
                <p class="text-justify">
                  The pre-launch platform to ONPASSIVE, O-Founders, gives you
                  the privilege to build your team and add to the Founders
                  family. Get guided by the top business leaders across the
                  globe who will show you the right path to success in your
                  life.
                </p>
                <p class="text-justify">
                  Get a smooth transition to ONPASSIVE to access the exclusively
                  designed AI business tools.
                </p>
                <div class="text-center mb-4">
                  <br />
                  <a
                    href="/registration/user?reg={{ userId }}"
                    target="_blank"
                    rel="noopener"
                    class="btn btn-outline-primary mt-3 btn-primary"
                    >Register Now</a
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide class="carousel-item active">
          <div class="product-bg trim-area-top">
            <div class="trim-top">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive-landing2/images/trim-top.png"
                alt="trim-top"
              />
            </div>
            <div class="row align-items-center justify-content-between">
              <div class="col-lg-4">
                <div class="products-logo">
                  <img
                    src="https://trimurl.co/images/logo.png"
                    class="img-fluid"
                    alt="Become a Founder | O-Founders  Sign UP"
                  />
                </div>
                <div class="products-view">
                  <h4 class="robo mb-4">
                    A Product Brought to you by ONPASSIVE
                  </h4>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="products-view">
                  <img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive-landing2/images/trim.png"
                    alt="trim"
                  />
                  <!--<h4 class="robo">"You are in it to win it"</h4>-->
                </div>
              </div>
              <div class="col-lg-12 mt-3">
                <p class="text-justify">
                  An URL shortener tool that is built to make email-friendly
                  links that can be used while marketing content across various
                  mediums, including blogs, instant messages, online
                  publications, and ad campaigns.
                </p>
                <p class="text-justify">
                  Lengthy URLs are often tough to share as links tend to break,
                  a character goes missing, might not fit in the space.. so many
                  issues. But then you need to share the link as it is vital.
                  What do you do? Use TrimURL to shorten the link and send it.
                </p>
                <p class="text-justify">
                  A necessary web solution, yet an extreme necessity for
                  businesses that operate completely online.
                </p>
                <div class="text-center mb-4">
                  <a
                    href="https://trimurl.co/"
                    target="_blank"
                    rel="noopener"
                    class="btn btn-outline-primary mt-3 btn-primary"
                    >TRIM URL LINK</a
                  >
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </div>
</section>
<section class="features">
  <div class="container">
    <h2 class="text-uppercase mb-5">Features</h2>
    <div class="row no-gutters">
      <div class="col-lg-4">
        <div class="features-inner">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-landing2/images/f1.png"
            alt="f1"
            class="w-100"
          />
          <div class="features-text text-center">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-landing2/images/ai2.png"
              alt="AI2"
              class="img-fluid"
            />
            <h4 class="robo">AI INDUCED</h4>
            <p>
              There is no better way to implement AI in your business than
              ONPASSIVE. All our products are meticulously hand-crafted by the
              experts keeping in mind all your business needs. Get that optimum
              result, which you have always been looking for with us.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="features-inner">
          <div class="features-text text-center">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-landing2/images/ai2.png"
              alt="Ai2"
              class="img-fluid"
            />
            <h4 class="robo">FOR EVERYONE</h4>
            <p>
              ONPASSIVE distinctly attracts attention as the platform is for
              everyone, whether you are fresher in the industry or have been
              into it for years. We have clearly kept in mind that ONPASSIVE is
              global and has been designed likewise.
            </p>
          </div>
          <img
            src="{{ onPassiveBaseUrl }}onpassive-landing2/images/feature.jpeg"
            alt="feature"
            class="w-100"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="features-inner">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-landing2/images/f3.png"
            alt="f3"
            class="w-100"
          />
          <div class="features-text text-center">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-landing2/images/ai2.png"
              alt="Ai2"
              class="img-fluid"
            />
            <h4 class="robo">HANDS-FREE</h4>
            <p>
              A uniquely coded plug and play system that is the first of its
              kind ever built as ONPASSIVE is fully automated. A click of the
              mouse is all you need to get things going. Get your business going
              even when you are sleeping or on vacation.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="testimonials products">
  <div class="container">
    <div class="row justify-content-center">
      <div class="testimonials-inner col-lg-10 text-center">
        <p>Testimonials</p>
        <div class="line"></div>
        <h2>Get inspired with the success stories</h2>
        <div id="testimonials" class="carousel slide" data-ride="carousel">
          <!-- The slideshow -->
          <owl-carousel-o [options]="SlideOptions">
            <ng-template carouselSlide class="carousel-item">
              <div class="testimonials-content">
                <p>
                  “YOU MUST BELIEVE” With ONPASSIVE I believe that we will
                  change the digital market with the new technology of
                  Artificial Intelligence (AI). As a O-Founders member, I can
                  only thank Mr. Ash for his vision and the opportunity he is
                  giving us to be able to believe that it is still worth having
                  hope for a better world. For everyone who joined ONPASSIVE to
                  have a vision and believe that we are making history. “YOU ARE
                  IN IT TO WIN” Thank you Mr.Ash and your Team
                </p>
              </div>
              <div class="testimonials-thumb">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/testimonials/Antonio-Resende.png"
                  alt="ONPASSIVE - Gursminder Dhillon Testimonial"
                />
              </div>
              <div class="bot">
                <h4>Antonio Resende</h4>
                <h6>Portugal</h6>
              </div> </ng-template
            >>
            <ng-template carouselSlide class="carousel-item">
              <div class="testimonials-content">
                <p>
                  Thank you, Mr. Ash and his team for creating an AI system
                  where everyone will be successful. I haven’t had much
                  experience in online business before, but since I know and
                  have been a part of ONPASSIVE, I have learned a lot and am
                  still learning.
                </p>
              </div>
              <div class="testimonials-thumb">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/testimonials/Alzbeta-Kozakova.png"
                  alt="ONPASSIVE - Gursminder Dhillon Testimonial"
                />
              </div>
              <div class="bot">
                <h4>Alzbeta Kozakova</h4>
                <h6>UK</h6>
              </div>
            </ng-template>
            <ng-template carouselSlide class="carousel-item">
              <div class="testimonials-content">
                <p>
                  Software development is incredibly complex. It is humanly
                  impossible to create large complex programs and have them
                  perform flawlessly without adequate testing. Thank you Ash
                  Mufareh and the ONPASSIVE staff for taking the time to ensure
                  the quality of the ONPASSIVE software.
                </p>
              </div>
              <div class="testimonials-thumb">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/testimonials/Leon-Daniel.png"
                  alt="ONPASSIVE - Gursminder Dhillon Testimonial"
                />
              </div>
              <div class="bot">
                <h4>Leon Daniel</h4>
                <h6>USA</h6>
              </div>
            </ng-template>
            <ng-template carouselSlide class="carousel-item">
              <div class="testimonials-content">
                <p>
                  My dream came true with ONPASSIVE. It was the best decision of
                  my life to join the ONPASSIVE Company. The future is a system
                  based on artificial intelligence, whereby success is
                  accessible to everyone. I am grateful to Mr. Ash Mufareh, the
                  CEO of the company, for his work.
                </p>
              </div>
              <div class="testimonials-thumb">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/testimonials/Magdolna-Bognar.png"
                  alt="ONPASSIVE - Gursminder Dhillon Testimonial"
                />
              </div>
              <div class="bot">
                <h4>Magdolna Bognar</h4>
                <h6>Hungary</h6>
              </div>
            </ng-template>
            <ng-template carouselSlide class="carousel-item">
              <div class="testimonials-content">
                <p>
                  Thank you so much Mr. Ash Mufareh, for coming up with a
                  solution to use artificial intelligence in such a powerful way
                  to empower humanity. Peace and love. I am in it to win it.
                </p>
              </div>
              <div class="testimonials-thumb">
                <img
                  src="{{
                    onPassiveBaseUrl
                  }}onpassive-landing2/images/testimonials/John-Harder.png"
                  alt="ONPASSIVE - Gursminder Dhillon Testimonial"
                />
              </div>
              <div class="bot">
                <h4>John Harder</h4>
                <h6>Mexico</h6>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="heart about" style="padding-top: 32px">
  <div class="col-lg-12 text-center">
    <a
      href="/registration/user?reg={{ userId }}"
      target="_blank"
      rel="noopener"
      class="btn btn-outline-primary mt-3 btn-primary"
      >Become A Founder Now</a
    >
  </div>
  <div class="container">
    <h5 class="robo">
      <div class="line-two"></div>
      Latest Blogs
    </h5>
    <h2 class="mb-4">Your access to our hottest updates</h2>
    <div class="bg-ball mt-4">
      <div class="row align-items-center">
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/effect-artificial-intelligence-fantasy-reality/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">Artificial Intelligence</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/ArtificialIntelligence-ONPASSIVEAI-768x768.jpg"
              alt="ONPASSIVE - A Flexible, Scalable and Secure  Innovation"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>
                The Effect of Artificial Intelligence from Fantasy to Reality
              </h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/new-trends-small-business-2021/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">O-Founders</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/Business-Trends-GoFounders-768x768.jpg"
              alt="Evolving Relationship with Technology"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>New Trends for Small Business in 2021</h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/6-positive-first-impression-tips-building-strong-brand/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">ONPASSIVE</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/Branding-ONPASSIVE-768x768.jpg"
              alt="Evolving Relationship with Technology"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>
                6 Positive First Impression Tips for Building a Strong Brand
              </h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="row align-items-center post-row">
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/will-make-all-our-dreams-come-true-onpassive/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">Community</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/JohnWhite-Community-768x768.jpg"
              alt="The Smart AI Solutions"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>ONPASSIVE Will Make All Our Dreams Come True!!</h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/super-excited-happy-part-onpassive/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">Testimonials</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/Linda-Awasiri-Testimonial-768x768.jpg"
              alt="ONPASSIVE - Review by Clementine Mccrowey"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>I’m Super Excited and Happy to Be Part of ONPASSIVE</h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
        <div class="col-lg-4">
          <a
            class="posts"
            href="https://onpassive.com/blog/9-wonderful-viral-marketing-techniques-proven-successful-facts/"
            target="_blank"
            rel="noopener"
          >
            <span class="categories-area">Marketing</span>
            <img
              src="https://onpassive.com/blog/wp-content/uploads/2020/12/Viral-Marketing-ONPASSIVE-768x768.jpg"
              alt="ONPASSIVE - Gregory Hill Testimonial"
              class="img-fluid"
            />
            <div class="post-content">
              <h3>
                9 Wonderful Viral Marketing Techniques with Proven Successful
                Facts
              </h3>
              <div class="date">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="26"
                  height="26"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#ffffff">
                      <path
                        d="M41.28,0c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-20.64c-3.7625,0 -6.88,3.1175 -6.88,6.88v58.48c-0.01344,1.23625 0.63156,2.39188 1.70656,3.02344c1.075,0.61813 2.39187,0.61813 3.46687,0c1.075,-0.63156 1.72,-1.78719 1.70656,-3.02344v-24.08h144.48v103.2h-144.48v-27.52c0.01344,-1.23625 -0.63156,-2.39187 -1.70656,-3.02344c-1.075,-0.61813 -2.39187,-0.61813 -3.46687,0c-1.075,0.63156 -1.72,1.78719 -1.70656,3.02344v27.52c0,3.7625 3.1175,6.88 6.88,6.88h144.48c3.7625,0 6.88,-3.1175 6.88,-6.88v-137.6c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-20.64v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88h-6.88c-3.7625,0 -6.88,3.1175 -6.88,6.88v6.88h-61.92v-6.88c0,-3.7625 -3.1175,-6.88 -6.88,-6.88zM41.28,6.88h6.88v20.64h-6.88v-9.74219c0.06719,-0.37625 0.06719,-0.7525 0,-1.11531zM123.84,6.88h6.88v9.74219c-0.06719,0.37625 -0.06719,0.7525 0,1.11531v9.7825h-6.88zM13.76,20.64h20.64v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h61.92v6.88c0,3.7625 3.1175,6.88 6.88,6.88h6.88c3.7625,0 6.88,-3.1175 6.88,-6.88v-6.88h20.64v27.52h-144.48zM57.835,76.15031c-1.3975,-0.02688 -2.67406,0.79281 -3.23844,2.06937c-0.55094,1.29 -0.26875,2.78156 0.71219,3.78938l16.985,17.75094h-61.97375c-1.23625,-0.01344 -2.39187,0.63156 -3.02344,1.70656c-0.61813,1.075 -0.61813,2.39187 0,3.46687c0.63156,1.075 1.78719,1.72 3.02344,1.70656h60.32094l-15.33219,16.03094c-1.31687,1.38406 -1.27656,3.56094 0.09406,4.86438c1.38406,1.31687 3.56094,1.27656 4.86437,-0.09406l20.1025,-21.01625c0.99438,-0.37625 1.74688,-1.16906 2.06938,-2.16344l1.84094,-1.92156l-23.99937,-25.10125c-0.63156,-0.67187 -1.51844,-1.075 -2.44563,-1.08844z"
                      ></path>
                    </g>
                  </g>
                </svg>
                17/12/2020
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center">
        <a
          href="https://onpassive.com/blog"
          target="_blank"
          rel="noopener"
          class="btn btn-outline-primary mt-5 btn-primary"
          >Read More</a
        >
      </div>
    </div>
  </div>
</section>
<section class="contact about">
  <div class="container">
    <div class="text-center">
      <h2 class="mb-4 text-uppercase">Don't Wait, Let's Talk</h2>
      <h5 class="robo">Let us know what you are thinking. We are hearing.</h5>
    </div>
    <div class="row justify-content-end">
      <div class="col-lg-5">
        <br />
        <div class="contact-form"></div>
      </div>
    </div>
  </div>
</section>
<footer class="site-footer text-center">
  <div class="copy">
    <div class="container">
      <p class="mb-0">&#169; 2020 ONPASSIVE - All Rights Reserved</p>
    </div>
  </div>
</footer>
